import React, {memo, useCallback, useEffect, useState} from 'react';
import '../ScenarioTriggerCreateScreen/index.scss';
import './index.scss';

import iconCancel from '../../assets/images/icons/scenario/cancel.png';
import iconSave from '../../assets/images/icons/scenario/save.png';
import iconScenario from '../../assets/images/icons/scenario/scenario.png';
import {
    FrameUIEntity,
    STPUIEntity,
    ScenarioModel,
} from '../../store/control/state';
import {useDispatch, useSelector} from 'react-redux';
import {useRPC} from '../../hooks/rpc';
import {useMessage} from '../../hooks/message';
import {onClickHandler} from '../../utils/onclick';
import {toggleScenarioTriggerInputScreenAction} from '../../store/ui/actions';
import {useLocalization} from "../../hooks/localization";
import flipIconActive from '../../assets/images/icons/scenario/flip-active.png'
import flipIconPassive from "../../assets/images/icons/scenario/flip-passive.png"
import { useSetSelector } from '../../hooks/set-selector';
import { BRIDGE_DEVICE_TYPE_ID_FRAME } from '../../types/control';

export const ScenarioTriggerControlUpdateScreen = memo(function ScenarioTriggerControlUpdateScreen() {
    const {t} = useLocalization();
    const scenarios = useSelector(state => state.control.scenarioList);
    const selectedTrigger = useSelector(state => state.ui.triggerControlScreen.selectedTrigger);
    const selectedInput = useSelector(state => state.control.inputList).find(r => r?.relational_id === selectedTrigger?.relational_id)
    const selectedSTPUIEntity = useSelector(state => state.ui.triggerControlScreen.selectedUIEntity) as any;
    const bridgeDeviceList = useSetSelector(state => state.control.bridgeDeviceList)

    const dispatch = useDispatch();
    const {failure} = useMessage();
    const [rpc] = useRPC();

    const [selectedScenario, setSelectedScenario] = useState<ScenarioModel>(null);
    const [reverseTrigger, setReverseTrigger] = useState(
        (selectedSTPUIEntity?.id
            ? selectedSTPUIEntity?.extras?.reverse_operation_type
            : selectedInput?.["scenario_settings"]?.reverse_operation_type) || ''
    )

    useEffect(() => {
        for (const scenario of scenarios) {
            if (selectedTrigger?.relational_id === scenario.id || selectedSTPUIEntity?.relational_id === scenario.id) {
                setSelectedScenario(scenario)
                break
            }
        }
        if (selectedSTPUIEntity?.id) {
            setReverseTrigger(selectedSTPUIEntity?.extras?.reverse_operation_type)
        } else {
            setReverseTrigger(selectedInput?.["scenario_settings"]?.reverse_operation_type)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTrigger, selectedSTPUIEntity, scenarios])


    const close = useCallback(() => {
        dispatch(toggleScenarioTriggerInputScreenAction(null));
    }, [dispatch]);

    const save = useCallback(() => {
        const selectedScenarioId = selectedScenario ? selectedScenario.id : null;
        if (selectedTrigger) {
            rpc.updateScenarioTriggerControl(selectedTrigger?.id, selectedScenarioId, reverseTrigger).then(close).catch(failure);
        } else {
            if (selectedSTPUIEntity?.['display_name'] !== undefined) {
                rpc.updateSTPUI({
                    ...(selectedSTPUIEntity as STPUIEntity),
                    relational_id: selectedScenarioId,
                    extras: {
                        ...selectedSTPUIEntity?.extras,
                        reverse_operation_type: reverseTrigger
                    }
                })
                    .then(close)
                    .catch(failure)
            } else {
                rpc.updateFrameUI({
                    ...(selectedSTPUIEntity as FrameUIEntity),
                    relational_id: selectedScenarioId
                })
                    .then(close)
                    .catch(failure)
            }
        }
    }, [selectedScenario, selectedTrigger, rpc, close, failure, selectedSTPUIEntity, reverseTrigger]);

    return (
        <div className='content-page scenario-trigger-control-update-screen'>
            <div className='content-divider top'>
                <div className='content-divider left'>
                    <div className='content-top'>
                        <div className='content-wrapper'>
                            <div className='action-row'>
                                <div className='action' {...onClickHandler(close)}>
                                    <img src={iconCancel} alt=''/>
                                    <span>{t('CANCEL')}</span>
                                </div>
                                <span>{selectedTrigger?.name || (selectedSTPUIEntity as STPUIEntity)?.display_name || (selectedSTPUIEntity as FrameUIEntity)?.extras?.name}</span>
                                <div className='action' {...onClickHandler(save)}>
                                    <img src={iconSave} alt=''/>
                                    <span>{t('SAVE')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='content-divider right'>
                    <div
                        className='content-wrapper' {...onClickHandler(() => {
                            setSelectedScenario(null)
                            setReverseTrigger("")
                        })}>
                        <div className='left-container'>
                            <img src={iconScenario} alt=''/>
                            <span>{t('NONE')}</span>
                        </div>
                         <div className='checkbox-opt-wrapper'>
                            <div className={'check-box' + (selectedScenario === null ? ' checked' : '')}/>
                        </div>
                    </div>
                    {
                        scenarios.map(scenario => (
                            <div
                                className='content-wrapper'>
                                <div className='left-container'>
                                    <img src={iconScenario} alt=''/>
                                    <span>{scenario.name}</span>
                                </div>
                                <div className='checkbox-opt-wrapper'>
                                    {renderIf(scenario?.is_reversible && bridgeDeviceList[selectedSTPUIEntity?.["bridge_device_id"]]?.type_id !== BRIDGE_DEVICE_TYPE_ID_FRAME)(() => (
                                        <>
                                        <div
                                        {...onClickHandler(() => {
                                            setSelectedScenario(scenario)
                                            setReverseTrigger('reverse')
                                        })}
                                            className={"check-box triangle-left" + (reverseTrigger === 'reverse' && selectedScenario === scenario ? " checked-triangle-left" : "")}
                                        />
                                        <div className='flip-icon-container' {...onClickHandler(() => {
                                            setSelectedScenario(scenario)
                                            setReverseTrigger('toggle')
                                        })}>
                                        <img src={reverseTrigger === 'toggle' && selectedScenario === scenario ? flipIconActive : flipIconPassive} alt="flip-icon"  />
                                        </div>
                                        </>

                                    ))}
                                    <div className={'check-box triangle-right' + (selectedScenario === scenario && !reverseTrigger? ' checked-triangle-right' : '')}
                                    {...onClickHandler(() => {
                                            setSelectedScenario(scenario)
                                            setReverseTrigger('')
                                        })}
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
});
